import React from 'react';
import { Hero } from './components/Hero';
import { BenefitsStrip } from './components/BenefitsStrip';
import { SocialProofBar } from './components/SocialProofBar';
import { PurchaseNotifications } from './components/PurchaseNotifications';
import { ProblemSection } from './components/ProblemSection';
import { NoNecesitasSection } from './components/NoNecesitasSection';
import { ProductIntro } from './components/ProductIntro';
import { TomosSection } from './components/TomosSection';
import { TomoCommonFeatures } from './components/TomoCommonFeatures';
import { InsideCarousel } from './components/InsideCarousel';
import { BenefitsGrid } from './components/BenefitsGrid';
import { BonosSection } from './components/BonosSection';
import { ValueStack } from './components/ValueStack';
import { PremiumIntro } from './components/PremiumIntro';
import { KitComparison } from './components/KitComparison';
import { PremiumItem } from './components/PremiumItem';
import { PricingCards } from './components/PricingCards';
import { ComparisonTable } from './components/ComparisonTable';
import { GuaranteeSection } from './components/GuaranteeSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { TransformationSection } from './components/TransformationSection';
import { ProofSection } from './components/ProofSection';
import { ForWhoSection } from './components/ForWhoSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { StickyMobileCTA } from './components/StickyMobileCTA';
import { PhraseSeparator } from './components/ui/PhraseSeparator';
import { KIT_IMAGES } from './data/images';
export function App() {
  return <div className="min-h-full w-full bg-mp-black font-body" data-id="element-0" data-mp="nvsvva68mxyl">
      <main data-id="element-1" data-mp="nvas7sh8xhgn">
        <Hero data-id="element-2" data-mp="nxn9e3f6jnsn" />
        <BenefitsStrip data-id="element-3" data-mp="sunbk38ws6eh" />
        <SocialProofBar data-id="element-4" data-mp="stuexv3nyxa2" />
        <ProblemSection data-id="element-5" data-mp="stccggqermtp" />
        <NoNecesitasSection data-id="element-6" data-mp="swqbpg3rzfwx" />
        <ProductIntro data-id="element-7" data-mp="3686fj9n0kvj" />
        <TomosSection data-id="element-8" data-mp="35glr3hkw7k1" />
        <PhraseSeparator phrase="NO SOLAMENTE QUÉ ENSEÑAR. CÓMO ENSEÑARLO." data-id="element-9" data-mp="34x29ica5b3w" />
        <TomoCommonFeatures data-id="element-10" data-mp="3ubrhql7qei4i" />
        <InsideCarousel data-id="element-11" data-mp="3ucje3y95kjvu" />
        <BenefitsGrid data-id="element-12" data-mp="d4nvzht0nm2x" />
        <BonosSection data-id="element-13" data-mp="d57d4waue6fw" />
        <PhraseSeparator phrase="MENOS DISCURSO. MÁS CLARIDAD." tone="lime" data-id="element-14" data-mp="d3cvprys4wgk" />
        <ValueStack data-id="element-15" data-mp="85bap1hsmn2g" />
        <PremiumIntro data-id="element-16" data-mp="86w60tbxma1d" />
        <KitComparison data-id="element-17" data-mp="83i3nl39q0tx" />
        <PremiumItem label="Extra Premium 01" title="El Mapa de Pista" tag="50 Esquemas Técnicos" copy={['La traducción visual de Maestro en Pista.', '50 esquemas de pista con posiciones, desplazamientos, conos y trayectorias para entender ejercicios y situaciones de juego de un vistazo.']} bigLine="MIRAS. ENTIENDES. MONTAS." smallNote={['Porque cuando estás en pista no quieres leer tres páginas para recordar un ejercicio.', 'Quieres verlo.']} imageLabel="Mapa de Pista" imageUrl={KIT_IMAGES.mapaDePista} data-id="element-18" data-mp="3gle9siuub3f6" />
        <PremiumItem label="Extra Premium 02" title="Programador 12 Meses" tag="Tu Calendario Anual" copy={['Una estructura anual para ayudarte a organizar qué trabajar durante la temporada y mantener una progresión más coherente a lo largo de los meses.']} bigLine="ABRES LA SEMANA. SABES QUÉ TOCA." smallNote={['Menos decisiones repetitivas.', 'Más continuidad.', 'Más control sobre la temporada.']} imageLabel="Programador 12 Meses" imageUrl={KIT_IMAGES.programador12Meses} reverse data-id="element-19" data-mp="18cq6rn0wyktz" />
        <TestimonialsSection data-id="element-20" data-mp="1i2sw9d8ttgnk" />
        <PricingCards data-id="element-21" data-mp="1i5ngp4rub1gz" />
        <ComparisonTable data-id="element-22" data-mp="1m4wauaqsl1d2" />
        <GuaranteeSection data-id="element-23" data-mp="1m4eezf81kp5o" />
        <PhraseSeparator phrase="DE TIRABOLAS A MONITOR CON MÉTODO." data-id="element-24" data-mp="1m3l7ud567xn0" />
        <TransformationSection data-id="element-25" data-mp="6o5uvka7smiq" />
        <ProofSection data-id="element-26" data-mp="6n48wkrnufm8" />
        <ForWhoSection data-id="element-27" data-mp="6qs21it7100f" />
        <FAQSection data-id="element-28" data-mp="aqisflet5e4f" />
        <FinalCTA data-id="element-29" data-mp="ar278t95vme8" />
      </main>
      <Footer data-id="element-30" data-mp="anwk3jk3eul5" />
      <StickyMobileCTA data-id="element-31" data-mp="ano95x7j5zcl" />
      <PurchaseNotifications data-id="element-32" data-mp="qxnlxln52ev2" />
    </div>;
}